import { object, string, array } from 'yup'

const schema = object({
  country: string().required('Please select a country'),
  mainDomain: string().required('Please enter the domain.'),
  brandWords: array().required('Please enter brand keywords'),
})

export default schema
